export default "__VITE_ASSET__DMsov5t9__"